<template>
    <div>
        <el-dialog
                :title="$t('TABLE_HEADER_fileNameList')"
                visible
                @close="onCancel"
                width="70%"
                top="10vh"
        >
            <el-table
                    border
                    :row-class-name="tableRowClassName"
                    :data="paginationData"
                    max-height="500"
                >
                <el-table-column
                        prop="name"
                        min-width="150"
                        show-overflow-tooltip
                        class-name="file-name-cell"
                        :label="$t('DOWNLOAD_FILE_NAME')">
                    <template slot-scope="scope">
                      <span v-if="calcDisableDownload(scope.row)">{{scope.row.name}}</span>
                      <span v-else class="file-name can-download" @click="onFileDownload(scope.row)">
                        <i class="el-icon-download" />
                        {{scope.row.name}}
                      </span>

                    </template>
                </el-table-column>
                <el-table-column
                        prop="size"
                        width="100"
                        show-overflow-tooltip
                        :label="$t('DOWNLOAD_SIZE')">
                    <template
                            slot-scope="scope">
                        <span>{{scope.row.size | fileSize}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="downloadDate"
                        show-overflow-tooltip
                        :label="$t('DOWNLOAD_TIME')">
                </el-table-column>
                <el-table-column
                        prop="downloadBy"
                        show-overflow-tooltip
                        :label="$t('DOWNLOAD_BY')">
                </el-table-column>
                <el-table-column
                        prop="uploadDate"
                        show-overflow-tooltip
                        :label="$t('UPLOAD_TIME')">
                </el-table-column>
                <el-table-column
                        prop="uploadBy"
                        show-overflow-tooltip
                        :label="$t('UPLOAD_BY')">
                </el-table-column>
                <el-table-column
                        prop="history"
                        width="85"
                        show-overflow-tooltip
                        align="center"
                        :label="$t('VERSION_HISTORY')">
                    <template slot-scope="scope">
                        <i class="el-icon-document pointer" v-if="scope.row.hasHistory && scope.row.hasHistory === 'YES'" @click="queryFileHistory(scope.row.name,scope.row.groupEntityTopicId)"/>
                    </template>
                </el-table-column>
                <el-table-column
                  prop="action"
                  width="70"
                  show-overflow-tooltip
                  align="center"
                  :label="$t('COMMON_DELETE')">
                    <template
                      slot-scope="scope"
                    >
                        <!-- 已接受条目不可删除 || 毕马威不可删除客户上传的文件 || 客户也不可删除毕马威上传的文件 -->
                        <i class="el-icon-delete delete" v-if="!noAuthority(scope.row)" @click="onDeleteClick(scope.row)"/>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="wl-pagination"
                    :total="total"
                    :current-page="current"
                    :page-size="pageSize"
                    :page-sizes="[10, 50, 100]"
                    @size-change="onSizeChange"
                    layout="prev, pager, next, sizes, total"
                    @current-change="handleCurrentChange">
            </el-pagination>

        </el-dialog>

<!--        历史记录-->
        <file-history
                v-if="historyVisible"
                :tableData='historyData'
                :curUserName="curUserName"
                :downloadAble="downloadAble"
                :onCancel="toogleFileHistoryVisible"
                :isComponentMember="isComponentMember"
                :componentDownload="componentDownload"
                @on-file-download="row => onFileDownload(row)"
                @queryFileHistory="row => queryFileHistory(row.name,row.groupEntityTopicId)"
        />
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import API from '@/api'
    import fileHistory from './file-history'
    import { userPermission } from '@/mixins/userPermission.js'
    export default {
        name: "file-detail",
        components: {
            fileHistory
        },
        props: {
            tableData: Array,
            onCancel: Function,
            id: String,
            curUserName: String,
            downloadAble: Boolean,
            isComponentMember: Boolean,
            activeTab: String
        },
        computed: {
            total() {
                return this.tableData.length;
            },
            paginationData() {
                const { tableData, current, pageSize } = this;
                const res = tableData.slice((current - 1) * pageSize, current * pageSize);
                return res;
            },
            ...mapGetters('common', {
                getSite: 'getSite',
                getUser: 'getUser'
            })
        },
        mixins: [userPermission],
        data(){
            return {
                current: 1,
                pageSize: 10,
                historyVisible: false,
                loading: false,
                historyData: [],
                componentDownload: false
            }
        },
        mounted() {
            this.getTileConfig()
        },
        methods: {
            noAuthority(file) {
                return file.uploadBy && file.uploadBy.indexOf('@') === -1 && this.getUser.userType === '2' ||
                  file.uploadBy && file.uploadBy.indexOf('@') !== -1 && this.getUser.userType === '1' ||
                  file.componentFlag != this.isComponentMember
            },
            /**
             * 客户之间不允许相互下载 || 没有下载权限
             *
             * @param {*} row
             */
            calcDisableDownload(row) {
                return !this.hasPermission('download') ||
                        this.getUser.userType === '2' &&
                        !this.downloadAble &&
                        row.uploadBy &&
                        row.uploadBy.indexOf('@') !== -1 &&
                        row.uploadBy.indexOf(this.curUserName) == -1 ||
                        // component用户能不能下载集团审计用户上传的文件，由一般设置中配置
                        this.isComponentMember && !row.componentFlag && !this.componentDownload
            },
            onDeleteClick(row) {
                const params = {
                    fileId: row.fileId,
                    id: row.groupEntityTopicId,
                    fileNameList: [row.name],
                    source: 'group',
                    ifDeleteHistory: true,
                    siteId: this.getSite.siteId
                }
                this.$confirm(this.$t('FILE_DELETE_WARNING_MSG'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    // 删除----
                    API.pbc.deletePbcFiles(params).then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.tableData.splice(this.tableData.findIndex(v => v.fileId == row.fileId), 1)
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                })
            },
            tableRowClassName({row, rowIndex}){
                if (row.uploadBy && row.uploadBy.indexOf('@') === -1) {
                    return 'kp-update-row';
                }
                return '';
            },
            onSizeChange(size) {
                this.current = 1
                this.pageSize = size
            },
            handleCurrentChange(val) {
                this.current = val;
            },
            onFileDownload (row) {
                 
                this.$emit('on-file-download', [{fileId: row.fileId,id: this.id,name: row.name}]);
            },
            clearHistoryFlag(fileName) {
                this.tableData.map(item => {
                    if(item.name === fileName) {
                        item.hasHistory = null
                    }
                })
            },
            async queryFileHistory(fileName,groupEntityTopicId){
                try {
                    this.historyVisible = true
                    this.loading = true
                    const { data, code } = await API.pbc.queryFileHistory({fileName,groupEntityTopicId,siteId: this.getSite.siteId,source: 'group'})
                    if (code === '1') {
                        if(data.length > 0) data.shift()
                        if(data.length === 0) {
                            this.clearHistoryFlag(fileName)
                        }
                        this.historyData = data.map(v => {
                            v.groupEntityTopicId = groupEntityTopicId
                            return v
                        })
                    } else {
                        this.$message.error(this.$t(code))
                    }
                    this.loading = false
                }
                catch(err) {}
                finally {}
            },
            toogleFileHistoryVisible(){
                this.historyVisible = !this.historyVisible
            },
            getTileConfig() {
                API.general.siteTilesGeneral({siteId: this.getSite.siteId}).then(res => {
                    if (res.code == '1') {
                        this.componentDownload = res.data.componentDownload == '1'
                    }
                }).catch(e => {}).finally(e => {})
            }
        }
    }
</script>

<style scoped>
    .file-name-cell .can-download {
        cursor: pointer;
        user-select: none;
    }
    .file-name-cell .file-name {
        display: inline-block;
        margin-right: 10px;
    }

    .file-name-cell .can-download:hover {
        color: rgb(120, 120, 195);
        text-decoration: underline;
    }
    .pointer{
        cursor: pointer;
        color: #3879eb;
    }
    .delete {
        color: #fd349c;
        cursor: pointer;
    }
    ::v-deep .kp-update-row {
       background: #0091da;
       color: #FFFFFF;
    }
    ::v-deep .el-table tr:hover{
        color: #636363;
    }
    .action-item {
        margin: 0 5px;
    }
    .action-item:hover {
        cursor: pointer;
        text-decoration: underline;
    }
    .el-icon-download {
        color: #3879EB;
    }
    ::v-deep .kp-update-row .el-icon-download {
        color: #fff;
    }
    ::v-deep .kp-update-row .pointer {
        color: #fff;
    }
    ::v-deep .kp-update-row:hover {
        color: #93637c;
    }
    ::v-deep .kp-update-row:hover .el-icon-download {
        color: #0091da;
    }
    ::v-deep .kp-update-row:hover .pointer {
        color: #0091da;
    }
</style>
